import { put, takeLatest, fork, call } from "redux-saga/effects";
import { ActionType } from "models/contract/inquiryDetail";
import { httpStatus } from "configs/httpStatus";
import { sendInquiryDetail } from "services/contractInformation";
import { handleSuccesAction, handleErrorAction } from "./inquiryDetailActions";
import {
  IInquiryDetailResponse,
  IInquiryDetailPayload,
} from "models/contract/inquiryDetail";

function* sendInquiryDetailSaga({
  payload,
}: {
  payload: IInquiryDetailPayload;
}) {
  try {
    const response: IInquiryDetailResponse = yield call(
      sendInquiryDetail,
      payload
    );
    if (
      response.status === httpStatus.StatusCreated ||
      response.status === httpStatus.StatusOK
    ) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onSendInquiryDetailWatcher() {
  yield takeLatest(
    ActionType.CONTRACT_INFORMATION_INQUIRY_DETAIL as any,
    sendInquiryDetailSaga
  );
}

export default [fork(onSendInquiryDetailWatcher)];
